import React, { Component } from 'react';
import { connect } from 'react-redux';

import Slider from 'rc-slider';
import moment from 'moment';

import { updateDates } from '../../FilterActions';

class DateSlider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 0,
      min: 0,
      max: 0
    };
  }

  componentDidMount() {
    this.updateState();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.dates.singleDate !== this.props.dates.singleDate) {
      const diff = moment(this.props.dates.singleDate).diff(this.props.dates.startDate, 'days');
      const max = moment(this.props.dates.endDate).diff(this.props.dates.startDate, 'days');
      this.setState({
        max,
        value: diff
      });
    }
    if (prevProps.hash !== this.props.hash) {
      this.reset();
    }
  }

  reset() {
    this.props.updateValue({
      ...this.props.dates,
      singleDate: moment(this.props.dates.endDate),
      daysFromStart: moment(this.props.dates.endDate).diff(this.props.dates.startDate, 'days')
    });
  }

  updateState() {
    const diff = moment(this.props.dates.endDate).diff(this.props.dates.startDate, 'days');
    this.setState({
      value: diff,
      max: diff
    });
  }

  handleChange = e => {
    this.setState({ value: e });
  };

  handleAfterChange = e => {
    this.props.updateValue({
      ...this.props.dates,
      singleDate: moment(this.props.dates.startDate).add(e, 'days'),
      daysFromStart: e
    });
  };

  decrease = () => {
    let value = this.state.value - 1;
    if (value < this.state.min) {
      return false;
    }

    this.setState({ value });
    this.handleAfterChange(value);
  };

  increase = () => {
    let value = this.state.value + 1;
    if (value > this.state.max) {
      return false;
    }

    this.setState({ value });
    this.handleAfterChange(value);
  };

  // Lucide "chevron-left" / "chevron-right", ISC licence, https://lucide.dev
  renderChevron(path) {
    return (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d={path} />
      </svg>
    );
  }

  rangeFormat() {
    const { startDate, endDate } = this.props.dates;
    if (moment(startDate).year() !== moment(endDate).year()) {
      return 'MMM YYYY';
    }
    return (this.props.format || 'DD MMM YYYY').replace(/[\s,./-]*YYYY[\s,./-]*/, '').trim();
  }

  render() {
    const { startDate, endDate } = this.props.dates;
    return (
      <div className="date-replay">
        <div className="date-replay-step">
          <button
            className="btn btn-default btn-white-shadow"
            disabled={this.state.value === this.state.min}
            onClick={this.decrease}
          >
            {this.renderChevron('m15 18-6-6 6-6')}
          </button>
          <span className="date-replay-date">
            {moment(startDate)
              .add(this.state.value, 'days')
              .format(this.props.format)}
          </span>
          <button
            className="btn btn-default btn-white-shadow"
            disabled={this.state.value === this.state.max}
            onClick={this.increase}
          >
            {this.renderChevron('m9 18 6-6-6-6')}
          </button>
        </div>
        <div className="slider-track">
          <Slider
            min={this.state.min}
            max={this.state.max}
            value={this.state.value}
            onChange={this.handleChange}
            onAfterChange={this.handleAfterChange}
          />
        </div>
        <div className="date-replay-range">
          <span>{moment(startDate).format(this.rangeFormat())}</span>
          <span>{moment(endDate).format(this.rangeFormat())}</span>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    updateValue: val => dispatch(updateDates(val, true))
  };
};

const mapStateToProps = state => {
  const chart = state.filters.chart;
  return {
    format: state.filters.dateFormat,
    dates: state.filters.dates,
    hash: state.filters[chart].hash
  };
};

const connected = connect(mapStateToProps, mapDispatchToProps)(DateSlider);
export { connected as DateSlider };
